import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import Onboarding from "@/pages/Onboarding";
import Agenda from "@/pages/Agenda";
import CalendarView from "@/pages/CalendarView";
import Leads from "@/pages/Leads";
import Customers from "@/pages/Customers";
import Analytics from "@/pages/Analytics";
import Settings from "@/pages/Settings";
import PublicBooking from "@/pages/PublicBooking";
import PortalDemo from "@/pages/PortalDemo";

function Protected({ children }) {
  const { user, business } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400">Caricamento...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "superadmin") return <Navigate to="/admin" replace />;
  if (business === null && loc.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return children;
}

function AdminProtected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400">Caricamento...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "superadmin") return <Navigate to="/app" replace />;
  return children;
}

function AppShell({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/p/:slug" element={<PublicBooking />} />
            <Route path="/portal-demo" element={<PortalDemo />} />
            <Route path="/admin" element={<AdminProtected><AdminDashboard /></AdminProtected>} />
            <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
            <Route path="/app" element={<Protected><AppShell><Agenda /></AppShell></Protected>} />
            <Route path="/app/calendario" element={<Protected><AppShell><CalendarView /></AppShell></Protected>} />
            <Route path="/app/lead" element={<Protected><AppShell><Leads /></AppShell></Protected>} />
            <Route path="/app/clienti" element={<Protected><AppShell><Customers /></AppShell></Protected>} />
            <Route path="/app/statistiche" element={<Protected><AppShell><Analytics /></AppShell></Protected>} />
            <Route path="/app/impostazioni" element={<Protected><AppShell><Settings /></AppShell></Protected>} />
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
